export default "/dist/files/icon_menage_quotidien_blanc.9f01fe14b6df4db488706135845a84e6.svg";